/**
 * Barrel público do domínio ControleAcesso (R3) — a ÚNICA porta de entrada
 * externa. Publica o mínimo que os consumidores de fora do domínio precisam:
 *
 * - `rotaPerfil` / `rotaAdicionarUsuarioObra`: `router/rotas/Geral.ts` e
 *   `router/rotas/Obra.ts` espalham os dois arrays nos respectivos layouts.
 * - `rotasGrupos` / `rotasEditorGrupo` (T109/T110, GOV-03/GOV-04):
 *   `router/rotas/Geral.ts` espalha no `LayoutGeral` — mesmo formato de array
 *   com `component:` lazy.
 * - `carregarControleAcessoAdicionarUsuario`: `router/rotas/Fabricacao.ts`
 *   reusa o COMPONENTE numa rota própria (path e nome diferentes de
 *   `rotaAdicionarUsuarioObra` — não dá pra reusar o array).
 *
 * **Por que uma função de carregamento, e não `export { default as ... }`
 * do componente (AD-045, literalmente).** Um re-export ESTÁTICO do `.vue`
 * faria o módulo dele (e a cadeia de import dele — `@/libs/AuthApi`, que tem
 * `useCounterStore()` em ESCOPO DE MÓDULO) ser avaliado assim que QUALQUER
 * coisa importasse o barrel — inclusive `router/rotas/Geral.ts`, que
 * `router/index.ts` alcança ESTATICAMENTE antes de `app.use(pinia)`. A
 * função abaixo só executa o `import()` dinâmico quando CHAMADA, dentro do
 * `component:` (lazy) de uma rota — nunca no boot. `ControleAcesso.vue` (o
 * painel de permissões, consumido só por `ControleAcessoPerfil.vue` dentro
 * do próprio domínio) não é exportado — ninguém de fora precisa dele.
 * Nenhum Api entra aqui porque o domínio não tem um: `AuthApi`/`PessoasApi`
 * são infra compartilhada de `src/libs/`, consumidas por dezenas de
 * domínios, não donas deste.
 */
export {
  rotaPerfil,
  rotaAdicionarUsuarioObra,
  rotasGrupos,
  rotasEditorGrupo,
  rotaAtribuirAcesso,
} from "./controleAcessoRotas";
export type { Pessoa, UsuarioLogado, Grupo } from "./ControleAcesso.type";

export const carregarControleAcessoAdicionarUsuario = () =>
  import("./ControleAcessoAdicionarUsuario.vue");
